import React from 'react'
import  {TextHighlight} from '../../components';
import {VisDiv} from '../../components';
import {useStateContext} from '../../context/StateContext';

const ViewLabelValueField = ({label, value, labelColor, valueColor, boldValue, boldLabel, highlight, noBorder, labelValueDistance, children}) => {
/*   if(valueType=="boolean"){

    return(
      <VisDiv rules={[label]} className='vlfield-container' style={{color:labelColor}}>
            <TextHighlight highlight={notification ? "red" : "blue"}>
                {value}
            </TextHighlight>
      </VisDiv>
    )
  } */
  const {LDB} = useStateContext()
  const labelFlex = labelValueDistance ? {flex:1} : {flex:1}
  const valueFlex = labelValueDistance ? {flex: labelValueDistance} : {flex:1.3}
  const traslateLabel = () => {
    if(label=="SCADENZA ESERCIZIO") return LDB("fields","assetExpiry")
    return label
}
const border = noBorder ? "vlfield-container-no-border" : "vlfield-container" 

  return (
    <div className = {border}>
        <VisDiv rules={[label]} className='vlfield-label-container' style={{color:labelColor, ...labelFlex}}>
          {
            !boldLabel ? `${traslateLabel()}:` : <h3>{traslateLabel()}:</h3>
          }
           
        </VisDiv>
        <div className='vlfield-value-container' style={{color:valueColor, ...valueFlex}}>
          {
            !boldValue ? 
            <TextHighlight highlight={highlight}>
              {value}
           </TextHighlight> :
            <TextHighlight highlight={highlight} boldValue>
                {value}
            </TextHighlight>
          }
             {children}

        </div> 
    </div>
  )
}

export default ViewLabelValueField
